import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvoicesListComponent } from './invoices-list.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
    declarations: [
        InvoicesListComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        ScrollingModule,
    ],
    exports: [
        InvoicesListComponent
    ]
})
export class InvoicesListModule { }
